<div class="pt-4">
    <div id="{{'questionTrendsBarResult' + chartId}}"></div>
</div>



